import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {
  httpHeaderOptions: any;

  constructor(public _http: HttpClient) {
    this.httpHeaderOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
  }

  applicationList() {
    return this._http.get(environment.apiEndpoint + 'add_application/', this.httpHeaderOptions);
  }

  addApplication(data) {
    return this._http.post(environment.apiEndpoint + 'add_application/', data);
  }

  applicationPermissionList() {
    return this._http.get(environment.apiEndpoint + 'applications_list/', this.httpHeaderOptions);
  }

  editApplication(id, data) {
    return this._http.put(environment.apiEndpoint + 'edit_application/' + id + '/', data);
  }

  getApplication(id) {
    return this._http.get(environment.apiEndpoint + 'edit_application/' + id + '/', this.httpHeaderOptions);
  }

  applicationListWithRole() {
    return this._http.get(environment.apiEndpoint + 'all_module_role_relation_mapping/', this.httpHeaderOptions);
  }

  getEdmsToken() {
    return this._http.get(environment.apiEndpoint + 'generate_user_edms_token/', this.httpHeaderOptions);
  }

  logoutEdmsToken(url) {
    return this._http.get(url);
  }

  getUserWisePolicyList(params?:any){
    if(params){
      return this._http.get(environment.apiEndpoint + 'user_policy_details/list/?'+params);
    }
    else{
      return this._http.get(environment.apiEndpoint + 'user_policy_details/list/?');
    }
    
  }

  policyAccept(id, data){
    return this._http.put(environment.apiEndpoint + 'user_accepted_policy/'+id+'/', data);
  }

  ssoURL(){
    return this._http.get(environment.apiEndpoint + 'user/generate_sso_url/');
  }
}
